var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visitor-feedback-details-modal"},_vm._l((_vm.feedback.feedback),function(response){return _c('div',{key:response.question_id},[_c('h4',[_vm._v(_vm._s(response.title))]),_c('p',[_vm._v(_vm._s(response.responses.filter(function (item) {
      return item && item.length > 1;
      }).toString() || '-'))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }